module.exports = __webpack_public_path__ + "static/media/announcementIcon.d4f656bc.svg";